import gql from 'graphql-tag';


export const add = gql`mutation CreateCompany($underwriter: CompanyInput!) {
    createCompany(company: $underwriter) {
        id
        name
        isUnderwriter
        rebateRate
        address
        country {
            id
            name
            isoCode
        }
    }
}`;

export const edit = gql`mutation EditCompany($id: ID!, $underwriter: CompanyInput!) {
    editCompany(id: $id, company: $underwriter) {
        id
        name
        isUnderwriter
        rebateRate
        address
        country {
            id
            name
            isoCode
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/underwriter.js